(function () {
  function setResult(root, state, title, copy) {
    var box = root.querySelector("[data-tt-val-result]");
    var t = root.querySelector("[data-tt-val-title]");
    var c = root.querySelector("[data-tt-val-copy]");
    if (box) {
      box.setAttribute("data-state", state);
      box.hidden = !title && !copy;
    }
    if (t) t.textContent = title || "";
    if (c) c.textContent = copy || "";
  }

  function norm(value) {
    return String(value || "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "")
      .trim();
  }

  function listHasProduct(rows, productId, productHandle) {
    var wantId = String(productId || "");
    var wantHandle = String(productHandle || "").toLowerCase();
    return (rows || []).some(function (row) {
      if (!row) return false;
      if (wantId && String(row.id || "") === wantId) return true;
      if (wantHandle && String(row.handle || "").toLowerCase() === wantHandle) return true;
      return false;
    });
  }

  function listHasSize(rows, sizeHandle, sizeLabel) {
    var wantHandle = norm(sizeHandle);
    var wantLabel = norm(sizeLabel);
    return (rows || []).some(function (row) {
      if (!row) return false;
      var handle = norm(row.handle || row.size_key);
      var display = norm(row.display_size);
      if (wantHandle && (handle === wantHandle || display === wantHandle)) return true;
      if (wantLabel && (handle === wantLabel || display === wantLabel)) return true;
      return false;
    });
  }

  function decide(root, data, handle, configuration) {
    var kind = root.getAttribute("data-kind") || "canonical";
    var productHandle = String(root.getAttribute("data-handle") || "").toLowerCase();
    var productId = String(root.getAttribute("data-product-id") || "");
    var sizeHandle = String(root.getAttribute("data-size-handle") || "");
    var sizeLabel = String(root.getAttribute("data-size") || "");
    var partLists = [
      data.undercarriage,
      data.canonical_tracks,
      data.rubber_tracks,
      data.tracks,
      data.attachments,
      data.drive_sprockets,
      data.front_idlers,
      data.rear_idlers,
      data.bottom_rollers,
      data.carrier_rollers,
      data.undercarriage_kits,
    ];
    var onPart = partLists.some(function (rows) {
      return listHasProduct(rows, productId, productHandle);
    });
    var onSize =
      listHasSize(data.fits, sizeHandle, sizeLabel) ||
      listHasSize(data.track_sizes, sizeHandle, sizeLabel);
    if ((handle === "bobcat-t870" || handle === "bobcat-t590") && !configuration) {
      return {
        state: "blocked",
        title: "Configuration required",
        copy: "T870 torsion vs suspension and T590 narrow vs wide stay blocked until that evidence is on the machine.",
      };
    }
    if (kind === "steel") {
      if (onPart) {
        return { state: "match", title: "Fitment Verified", copy: "" };
      }
      return {
        state: "blocked",
        title: "Not on this machine’s parts lists",
        copy: "We will not treat a reverse catalog chip as a fit. Send make, model, and serial on the quote.",
      };
    }
    if (onPart || onSize) {
      return { state: "match", title: "Fitment Verified", copy: "" };
    }
    return {
      state: "blocked",
      title: "No public fitment for this pair",
      copy: "BLOCKED is valid. Do not order from a guessed application.",
    };
  }

  function selectedHandle(root) {
    var handleEl = root.querySelector("[data-tt-sel-handle]");
    if (handleEl && handleEl.value) return handleEl.value;
    var modelEl = root.querySelector("[data-tt-sel-model]");
    return modelEl ? String(modelEl.value || "").trim() : "";
  }

  function runCheck(root) {
    var makeEl = root.querySelector("[data-tt-sel-make]");
    var modelEl = root.querySelector("[data-tt-sel-model]");
    var configEl = root.querySelector("[data-tt-sel-config]");
    var make = makeEl ? String(makeEl.value || "").trim() : "";
    var handle = selectedHandle(root);
    if (makeEl) makeEl.classList.toggle("is-invalid", !make);
    if (modelEl) modelEl.classList.toggle("is-invalid", !handle);
    if (!make || !handle) {
      setResult(root, "blocked", "Make and model required", "The part is not the machine.");
      return;
    }
    var configuration = configEl && !configEl.closest("[hidden]") ? String(configEl.value || "").trim() : "";
    if ((handle === "bobcat-t870" || handle === "bobcat-t590") && !configuration) {
      setResult(root, "blocked", "Configuration required", "Pick torsion/suspension or narrow/wide before MATCH.");
      return;
    }
    setResult(root, "pending", "Checking the machine lists…", "Live equipment read. Not a catalog guess.");
    var client = new window.TTMachineSelector.Client({
      apiBase: root.getAttribute("data-api-base"),
      finderUrl: root.getAttribute("data-finder-url"),
    });
    client
      .loadMachine(handle, configuration)
      .then(function (machine) {
        root.setAttribute("data-equipment", handle);
        var verdict = decide(root, machine, handle, configuration);
        setResult(root, verdict.state, verdict.title, verdict.copy);
      })
      .catch(function () {
        setResult(
          root,
          "blocked",
          "Could not read this machine",
          "Fail closed. Quote with the plate — do not treat listed chips as a yes."
        );
      });
  }

  function wireQuote(root) {
    var link = root.querySelector("[data-tt-val-quote]");
    if (!link) return;
    link.addEventListener("click", function () {
      var makeEl = root.querySelector("[data-tt-sel-make]");
      var modelEl = root.querySelector("[data-tt-sel-model]");
      var url = new URL(link.href, window.location.origin);
      if (makeEl && makeEl.value) url.searchParams.set("make", makeEl.value.trim());
      if (modelEl && modelEl.selectedOptions[0] && modelEl.selectedOptions[0].dataset.model) {
        url.searchParams.set("model", modelEl.selectedOptions[0].dataset.model);
      }
      var handle = selectedHandle(root);
      if (handle) url.searchParams.set("equipment", handle);
      url.searchParams.set("source", "pdp_validator");
      link.href = url.pathname + "?" + url.searchParams.toString();
    });
  }

  function mount(root) {
    var btn = root.querySelector("[data-tt-val-check]");
    if (btn) btn.addEventListener("click", function () { runCheck(root); });
    root.addEventListener("tt-machine:selected", function (ev) {
      var handle = ev.detail && ev.detail.handle;
      if (handle) root.setAttribute("data-equipment", handle);
      if (ev.detail && ev.detail.machine && !ev.detail.needsConfig) runCheck(root);
    });
    wireQuote(root);
  }

  document.querySelectorAll("[data-tt-pdp-validator]").forEach(mount);
})();
